import * as React from 'react';
import { Route } from 'react-router';

import { StatsigProvider } from '@coursera-web/statsig';

import { Route as CourseraRoute } from '@coursera/react-router';

import NotFound from 'bundles/phoenix/components/NotFound';
import EnterpriseOrgScopedReviewsApp from 'bundles/reviews/components/EnterpriseOrgScopedReviewsApp';
import ReviewsApp from 'bundles/reviews/components/ReviewsApp';
import ReviewsPageDirector from 'bundles/reviews/components/ReviewsPageDirector';
import UnifiedUserExperienceHandler from 'bundles/unified-common/providers/UnifiedUserExperienceHandler';

const ReviewsAppWithUserExperienceHandler = (props: React.ComponentProps<typeof ReviewsApp> & object) => (
  <StatsigProvider>
    <UnifiedUserExperienceHandler>
      <ReviewsApp {...props} />
    </UnifiedUserExperienceHandler>
  </StatsigProvider>
);

export default (
  <Route>
    <Route path="/organizations/:orgSlug" component={EnterpriseOrgScopedReviewsApp}>
      <CourseraRoute
        handle={{
          tracking: {
            data: (params) => ({
              page: { type: 'course_reviews', segment: 'enterprise' },
              enterprise: {
                ...(params?.orgSlug ? { organizationSlug: params.orgSlug } : {}),
              },
            }),
          },
        }}
        path="learn/:slug/reviews"
        component={ReviewsPageDirector}
      />
      <CourseraRoute
        handle={{
          tracking: {
            data: (params) => ({
              page: { type: 'project_reviews', segment: 'enterprise' },
              enterprise: {
                ...(params?.orgSlug ? { organizationSlug: params.orgSlug } : {}),
              },
            }),
          },
        }}
        path="projects/:slug/reviews"
        component={ReviewsPageDirector}
      />
    </Route>
    <Route path="/" component={ReviewsAppWithUserExperienceHandler}>
      <CourseraRoute
        handle={{
          tracking: {
            data: () => ({
              page: { type: 'course_reviews', segment: 'consumer' },
            }),
          },
        }}
        path="learn/:slug/reviews"
        component={ReviewsPageDirector}
      />
      <CourseraRoute
        handle={{
          tracking: {
            data: () => ({
              page: { type: 'project_reviews', segment: 'consumer' },
            }),
          },
        }}
        path="projects/:slug/reviews"
        component={ReviewsPageDirector}
      />
      <CourseraRoute
        handle={{
          tracking: {
            data: (params) => ({
              page: { type: 'course_reviews', segment: 'enterprise' },
              enterprise: {
                ...(params?.programSlug ? { programSlug: params.programSlug } : {}),
              },
            }),
          },
        }}
        path="/programs/:programSlug/learn/:slug/reviews"
        component={ReviewsPageDirector}
      />
      <CourseraRoute
        handle={{
          tracking: {
            data: (params) => ({
              page: { type: 'project_reviews', segment: 'enterprise' },
              enterprise: {
                ...(params?.programSlug ? { programSlug: params.programSlug } : {}),
              },
            }),
          },
        }}
        path="/programs/:programSlug/projects/:slug/reviews"
        component={ReviewsPageDirector}
      />
      <Route path="*" component={NotFound} />
    </Route>
  </Route>
);
